export enum ProgrammeCoursera {
  PROGR_CLASSE_A = 'PROGR_CLASSE_A',
  PROGR_CLASSE_B = 'PROGR_CLASSE_B',
}
